export enum FieldTypeEnum{
  dropList ='Droplist',
  textBox = 'Text Box'
}
